import { enqueueSnackbar } from "notistack";

function CheckApiStatus(response) {
  if (response && response.status) {
    return true;
  } else {
    enqueueSnackbar(" -- Check Api Status -- ", {
      variant: "error",
    });
    return false;
  }
}

export default CheckApiStatus;
